import React from 'react'
import { mapPumpUnitToCard } from './pumpCardHelpers'
import PumpStatusTooltip from './PumpStatusTooltip'

export const PumpStatusCell = ({ unit, onSelectPump, className = '', style, unbillableLabel = 'Not in subscription' }) => {
  const p = mapPumpUnitToCard(unit)
  return (
    <div
      className={`fdStatusCell ${!p.active ? 'fdStatusCell--idle' : ''}${!p.billable ? ' fdStatusCell--unbillable' : ''} ${className}`}
      style={style}
      title={!p.billable ? unbillableLabel : undefined}
      onClick={p.selectable ? () => onSelectPump?.(unit) : undefined}
    >
      <div className="fdStatusId">
        <PumpStatusTooltip unit={unit} disabled={!p.billable}>
          <span
            className={`fdDot${p.billable ? ' fdDot--status' : ''}${p.pulse ? ' fdDot--pulse' : ''}`}
            style={{ background: p.statusColor, '--fd-active': p.statusColor }}
          />
        </PumpStatusTooltip>
        {p.name}
      </div>
      <div className="fdStatusRate">{p.statusPrimary}</div>
      <div className="fdStatusPsi">{p.statusSecondary}</div>
    </div>
  )
}

const PumpStatusGrid = ({ pumps = [], onSelectPump, waitingLabel = 'Waiting for data…', unbillableLabel }) => {
  if (!pumps.length) {
    return <div className="fleetEmptyState">{waitingLabel}</div>
  }

  return (
    <div className="fdGrid">
      {pumps.map((unit) => (
        <PumpStatusCell key={unit.unitUId} unit={unit} onSelectPump={onSelectPump} unbillableLabel={unbillableLabel} />
      ))}
    </div>
  )
}

export default PumpStatusGrid
